import { Dropdown, Button } from "antd"
import { useTranslation } from "react-i18next"
import { useState, useEffect } from "react"
import { DownOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import { routes } from "router/routes"
import PropTypes from "prop-types"
import styles from "./index.module.css"

const getContactActions = (t, setType) => ({
  items: [
    {
      key: "send_email",
      label: t("client.contact.send_email"),
      onClick: () => setType("email")
    },
    {
      key: "send_message",
      label: t("client.contact.send_message"),
      onClick: () => setType("message")
    },
    {
      key: "send_text",
      label: t("client.contact.send_text"),
      onClick: () => setType("text")
    }
  ]
})

const GuideContact = ({ client }) => {
  const { id } = client || {}
  const { t } = useTranslation()
  const [type, setType] = useState("")
  const navigate = useNavigate()
  // const templatesCollection = client[`${type}_templates_collection`]
  useEffect(() => {
    if (type) {
      switch (type) {
        case "email":
          navigate(routes.ClientEmailActionPath(), { state: { clients: [client], userIds: [id], guide: true } })
          break
        case "text":
          navigate(routes.ClientTextActionPath(), { state: { clients: [client], userIds: [id], guide: true } })
          break
        default:
          navigate(routes.ClientMessageActionPath(), {
            state: { clients: [client], userIds: [id], guide: true }
          })
      }
    }
    return () => {
      setType("")
    }
  }, [type, client, navigate, id])
  return (
    <div className={styles.contactCol}>
    <Dropdown
      className={`px-xl py-l`}
      placement="bottomRight"
      trigger={["click"]}
      menu={getContactActions(t, setType)}
      overlayClassName="contactDropdown"
    >
      <Button type="primary" icon={<DownOutlined />} iconPosition="end">
        {t("global.contact")}
      </Button>
    </Dropdown>
    </div>
  )
}

GuideContact.propTypes = {
  client: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    user_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    email_templates_collection: PropTypes.array,
    message_templates_collection: PropTypes.array
  }).isRequired
}

export default GuideContact
